import { render, staticRenderFns } from "./PasteCard.vue?vue&type=template&id=2529d070&"
import script from "./PasteCard.vue?vue&type=script&lang=js&"
export * from "./PasteCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports